import React from "react";
import { User, Building2 } from "lucide-react";
import Modal from "../Modal/Modal";

/* =======================
   Styles
======================= */
import styles from "./ViewUserModal.module.scss";

const ViewUserModal = ({ open, onClose, user, fields = [] }) => {
  if (!open || !user) return null;

  // Split fields into respective sections
  const userFields = fields.slice(0, 8);
  const orgFields = fields.slice(8);

  return (
    <Modal title="User Details" onClose={onClose}>
      <div className={styles["admin-vum__container"]}>
        {/* ===================== USER INFORMATION ===================== */}
        {userFields.length > 0 && (
          <div className={styles["admin-vum__section"]}>
            <div className={styles["admin-vum__section-header"]}>
              <div className={styles["admin-vum__icon-wrapper"]}>
                <User size={18} strokeWidth={2.5} />
              </div>
              <h3 className={styles["admin-vum__section-title"]}>
                User Information
              </h3>
            </div>

            <div className={styles["admin-vum__grid"]}>
              {userFields.map((field, index) => (
                <div key={index} className={styles["admin-vum__field"]}>
                  <span className={styles["admin-vum__label"]}>
                    {field.label}
                  </span>
                  <span className={styles["admin-vum__value"]}>
                    {field.value(user) || "--"}
                  </span>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* ===================== ORGANIZATION INFORMATION ===================== */}
        {orgFields.length > 0 && (
          <div className={styles["admin-vum__section"]}>
            <div className={styles["admin-vum__section-header"]}>
              <div className={styles["admin-vum__icon-wrapper"]}>
                <Building2 size={18} strokeWidth={2.5} />
              </div>
              <h3 className={styles["admin-vum__section-title"]}>
                Organization Information
              </h3>
            </div>

            <div className={styles["admin-vum__grid"]}>
              {orgFields.map((field, index) => (
                <div key={index} className={styles["admin-vum__field"]}>
                  <span className={styles["admin-vum__label"]}>
                    {field.label}
                  </span>
                  <span className={styles["admin-vum__value"]}>
                    {field.value(user) || "--"}
                  </span>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default ViewUserModal;
